// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__26VZu","approved":"Status_approved__DTyXO","rejected":"Status_rejected__1X9SR","expired":"Status_expired__3YOa0","label":"Status_label__K-rvz"};